var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("Price.LCLFreightDetails"),
        width: "990px",
        "close-on-click-modal": false,
        "destroy-on-close": true,
        top: "5vh",
        "custom-class": "details-view lcl-form"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c("div", { staticClass: "main-content" }, [
        _c(
          "div",
          { staticStyle: { "margin-bottom": "10px" } },
          [
            _c(
              "el-button",
              {
                attrs: { no: "onSubmit", type: "primary" },
                on: { click: _vm.onSubmit }
              },
              [_vm._v(_vm._s(_vm.$t("Pricing.Save")))]
            ),
            _c(
              "el-button",
              { attrs: { no: "onCancel" }, on: { click: _vm.onCancel } },
              [_vm._v(_vm._s(_vm.$t("Pricing.Cancel")))]
            )
          ],
          1
        ),
        _c("div", { staticStyle: { width: "fit-content" } }, [
          _c("div", { staticStyle: { display: "flex" } }, [
            _c(
              "div",
              { staticClass: "section form-column" },
              [
                _c(
                  "el-form",
                  {
                    attrs: {
                      disabled: _vm.readonly,
                      "label-width": "100px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.PriceNo") } },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "priceNo",
                            value: _vm.price.priceNo,
                            disabled: true
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "pol",
                        attrs: { required: "", label: _vm.$t("Pricing.POL") }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "pol",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Seaport,
                            "custom-label": function(item) {
                              return "[" + item.code + "]" + item.englishName
                            },
                            "filter-tag-names": ["code", "englishName"],
                            "show-custom-label-in-option": true,
                            "default-value": _vm.price.pol,
                            filterable: ""
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.pol = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "pod",
                        attrs: { required: "", label: _vm.$t("Pricing.POD") }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "pod",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Seaport,
                            "custom-label": function(item) {
                              return "[" + item.code + "]" + item.englishName
                            },
                            "filter-tag-names": ["code", "englishName"],
                            "show-custom-label-in-option": true,
                            "default-value": _vm.price.pod,
                            filterable: ""
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.pod = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: " " } },
                      [
                        _c("el-checkbox", {
                          attrs: {
                            no: "direct",
                            label: _vm.$t("Pricing.Direct")
                          },
                          model: {
                            value: _vm.price.direct,
                            callback: function($$v) {
                              _vm.$set(_vm.price, "direct", $$v)
                            },
                            expression: "price.direct"
                          }
                        })
                      ],
                      1
                    ),
                    !_vm.price.direct
                      ? _c(
                          "el-form-item",
                          {
                            ref: "via",
                            attrs: {
                              required: true,
                              label: _vm.$t("Pricing.Via")
                            }
                          },
                          [
                            _c("cargo-advance-select", {
                              attrs: {
                                no: "via",
                                "select-type":
                                  _vm.selectTypeNames.basic_data_Seaport,
                                "custom-label": function(item) {
                                  return (
                                    "[" + item.code + "]" + item.englishName
                                  )
                                },
                                "filter-tag-names": ["code", "englishName"],
                                "show-custom-label-in-option": true,
                                "default-value": _vm.price.via,
                                filterable: ""
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.price.via = p.value
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-form-item",
                      {
                        ref: "term",
                        attrs: {
                          required: "",
                          label: _vm.$t("Pricing.PaymentTerm")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "term",
                            "select-type":
                              _vm.selectTypeNames
                                .local_cache_PriceConstant$PAYMENT_TERMS,
                            "show-custom-label-in-option": true,
                            "default-value": _vm.price.term
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.term = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "carrier",
                        attrs: {
                          required: "",
                          label: _vm.$t("Pricing.Carrier")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "carrier",
                            filterable: "",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Company,
                            "method-params": { seaCmp: true },
                            "custom-label": function(item) {
                              return (
                                "[" + item.shortName + "]" + item.chineseName
                              )
                            },
                            "show-custom-label-in-option": true,
                            "default-value": _vm.price.carrier
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.carrier = p.cmpIdx
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "bookingAgent",
                        attrs: { required: "", label: _vm.$t("Pricing.Source") }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "bookingAgent",
                            filterable: "",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Company,
                            "method-params": { bookingAgent: true },
                            "custom-label": function(item) {
                              return "" + item.chineseName
                            },
                            "show-custom-label-in-option": true,
                            "default-value": _vm.price.bookingAgent
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.bookingAgent = p.cmpIdx
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.RateGrade") } },
                      [
                        _c("rate-grade", {
                          attrs: {
                            no: "gradeUnit",
                            "grade-min": _vm.price.gradeMin,
                            "grade-max": _vm.price.gradeMax,
                            "grade-unit": _vm.price.gradeUnit,
                            "show-unit": true
                          },
                          on: {
                            onChangeMin: function(p) {
                              _vm.price.gradeMin = p
                            },
                            onChangeMax: function(p) {
                              _vm.price.gradeMax = p
                            },
                            onChangeUnit: function(p) {
                              _vm.price.gradeUnit = p
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.ShippingLine") } },
                      [
                        _c("el-input", {
                          attrs: { no: "shippingLine", maxlength: 16 },
                          model: {
                            value: _vm.price.shippingLine,
                            callback: function($$v) {
                              _vm.$set(_vm.price, "shippingLine", $$v)
                            },
                            expression: "price.shippingLine"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.ContractNo") } },
                      [
                        _c("el-input", {
                          attrs: { no: "contractNo", maxlength: 32 },
                          model: {
                            value: _vm.price.contractNo,
                            callback: function($$v) {
                              _vm.$set(_vm.price, "contractNo", $$v)
                            },
                            expression: "price.contractNo"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.CabinNature") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "share",
                            "select-type":
                              _vm.selectTypeNames
                                .local_cache_PriceConstant$CABIN_NATURE,
                            "show-custom-label-in-option": true,
                            "default-value": _vm.price.share
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.share = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("Pricing.ShareCarriers"),
                          prop: "shareCarrier"
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("cargo-advance-select", {
                              staticStyle: { flex: "1" },
                              attrs: {
                                no: "carrier",
                                "select-type":
                                  _vm.selectTypeNames.basic_data_Company,
                                "method-params": { seaCmp: true },
                                filterable: "",
                                "default-value": _vm.share.carrier,
                                "custom-label": function(item) {
                                  return (
                                    "[" +
                                    item.shortName +
                                    "]" +
                                    item.chineseName
                                  )
                                },
                                "show-custom-label-in-option": true,
                                "tag-value": "cmpIdx"
                              },
                              on: {
                                parentCallBack: function(item) {
                                  return (_vm.share.carrier = item.value)
                                }
                              }
                            }),
                            _c(
                              "span",
                              {
                                staticClass: "form-operator",
                                on: {
                                  click: function($event) {
                                    return _vm.onPriceSubscribeFormAdd(
                                      "carrier"
                                    )
                                  }
                                }
                              },
                              [_c("i", { staticClass: "el-icon-circle-plus" })]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "form-operator",
                                on: {
                                  click: function($event) {
                                    return _vm.onPriceSubscribeFormRemove(
                                      "carrier"
                                    )
                                  }
                                }
                              },
                              [_c("i", { staticClass: "el-icon-remove" })]
                            )
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "custom",
                        attrs: { prop: "shareCarrierCodes" }
                      },
                      [
                        _c(
                          "el-checkbox-group",
                          {
                            attrs: { no: "carrierCodes" },
                            model: {
                              value: _vm.share.carrierCodes,
                              callback: function($$v) {
                                _vm.$set(_vm.share, "carrierCodes", $$v)
                              },
                              expression: "share.carrierCodes"
                            }
                          },
                          _vm._l(_vm.carrierCheckBoxGroup, function(code) {
                            return _c(
                              "el-col",
                              { key: code, attrs: { span: 8 } },
                              [
                                _c(
                                  "el-checkbox",
                                  {
                                    attrs: {
                                      no: "carrierCode",
                                      label: code,
                                      title: code
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.resolveColumnLabel(
                                          _vm.selectTypeNames
                                            .basic_data_Company,
                                          "cmpIdx",
                                          Number(code),
                                          "shortName"
                                        )
                                      )
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.TransportMode") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "transportMode",
                            filterable: "",
                            "select-type":
                              _vm.selectTypeNames.basic_data_ShippingTerm,
                            placeholder: _vm.$t("Pricing.PlsSelect"),
                            multiple: true,
                            "default-multiple-value": _vm.price.transportMode,
                            "tag-value": "name"
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.transportMode = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.SubContractNo") } },
                      [
                        _c("el-input", {
                          attrs: { no: "subContractNo", maxlength: 32 },
                          model: {
                            value: _vm.price.subContractNo,
                            callback: function($$v) {
                              _vm.$set(_vm.price, "subContractNo", $$v)
                            },
                            expression: "price.subContractNo"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.NA") } },
                      [
                        _c("el-input", {
                          attrs: { no: "na", maxlength: 32 },
                          model: {
                            value: _vm.price.na,
                            callback: function($$v) {
                              _vm.$set(_vm.price, "na", $$v)
                            },
                            expression: "price.na"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.NaCode") } },
                      [
                        _c("el-input", {
                          attrs: { no: "naCode", maxlength: 32 },
                          model: {
                            value: _vm.price.naCode,
                            callback: function($$v) {
                              _vm.$set(_vm.price, "naCode", $$v)
                            },
                            expression: "price.naCode"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "section form-column",
                staticStyle: { "min-width": "340px" }
              },
              [
                _c(
                  "el-form",
                  {
                    attrs: {
                      disabled: _vm.readonly,
                      "label-width": "100px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        ref: "currency",
                        attrs: {
                          required: "",
                          label: _vm.$t("Pricing.Currency")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "currency",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Currency,
                            clearable: false,
                            "default-value": _vm.price.currency
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.currency = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.COST_VAT") } },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "100%" },
                              attrs: { no: "costVat", type: "number" },
                              on: { change: _vm.costVatChange },
                              model: {
                                value: _vm.costVat,
                                callback: function($$v) {
                                  _vm.costVat = $$v
                                },
                                expression: "costVat"
                              }
                            }),
                            _c("label", [_vm._v(" %")])
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.SELL_VAT") } },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "100%" },
                              attrs: { no: "sellVat", type: "number" },
                              on: { change: _vm.sellVatChange },
                              model: {
                                value: _vm.sellVat,
                                callback: function($$v) {
                                  _vm.sellVat = $$v
                                },
                                expression: "sellVat"
                              }
                            }),
                            _c("label", [_vm._v(" %")])
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.DestinationDock") } },
                      [
                        _c("el-input", {
                          attrs: { no: "destinationDock", maxlength: 32 },
                          model: {
                            value: _vm.price.destinationDock,
                            callback: function($$v) {
                              _vm.$set(_vm.price, "destinationDock", $$v)
                            },
                            expression: "price.destinationDock"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("Pricing.CostPrice") + "(COST)" }
                      },
                      [
                        _c("pair-numeric-stepper", {
                          attrs: {
                            no: "costWeightPrice",
                            one: _vm.price.costWeightPrice,
                            two: _vm.price.costVolumePrice,
                            three: _vm.price.minimumTonCost,
                            "show-three": true,
                            "one-prompt": _vm.$t("Pricing.CostPrice"),
                            "two-prompt": _vm.$t("Pricing.VolumePrice"),
                            "three-prompt": _vm.$t("Pricing.MinimumPrice")
                          },
                          on: {
                            onChangeOne: function(p) {
                              _vm.price.costWeightPrice = p
                            },
                            onChangeTwo: function(p) {
                              _vm.price.costVolumePrice = p
                            },
                            onChangeThree: function(p) {
                              _vm.price.minimumTonCost = p
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("Pricing.ColoaderPrice") + "(T1)"
                        }
                      },
                      [
                        _c("pair-numeric-stepper", {
                          attrs: {
                            no: "oneWeightPrice",
                            one: _vm.price.oneWeightPrice,
                            two: _vm.price.oneVolumePrice,
                            three: _vm.price.minimumTonPrice1,
                            "show-three": true,
                            "one-prompt": _vm.$t("Pricing.CostPrice"),
                            "two-prompt": _vm.$t("Pricing.VolumePrice"),
                            "three-prompt": _vm.$t("Pricing.MinimumPrice")
                          },
                          on: {
                            onChangeOne: function(p) {
                              _vm.price.oneWeightPrice = p
                            },
                            onChangeTwo: function(p) {
                              _vm.price.oneVolumePrice = p
                            },
                            onChangeThree: function(p) {
                              _vm.price.minimumTonPrice1 = p
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("Pricing.CustomerPrice") + "(T2)"
                        }
                      },
                      [
                        _c("pair-numeric-stepper", {
                          attrs: {
                            no: "twoWeightPrice",
                            one: _vm.price.twoWeightPrice,
                            two: _vm.price.twoVolumePrice,
                            three: _vm.price.minimumTonPrice2,
                            "show-three": true,
                            "one-prompt": _vm.$t("Pricing.CostPrice"),
                            "two-prompt": _vm.$t("Pricing.VolumePrice"),
                            "three-prompt": _vm.$t("Pricing.MinimumPrice")
                          },
                          on: {
                            onChangeOne: function(p) {
                              _vm.price.twoWeightPrice = p
                            },
                            onChangeTwo: function(p) {
                              _vm.price.twoVolumePrice = p
                            },
                            onChangeThree: function(p) {
                              _vm.price.minimumTonPrice2 = p
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("Pricing.MarketPrice") + "(T3)" }
                      },
                      [
                        _c("pair-numeric-stepper", {
                          attrs: {
                            no: "threeWeightPrice",
                            one: _vm.price.threeWeightPrice,
                            two: _vm.price.threeVolumePrice,
                            three: _vm.price.minimumTonPrice3,
                            "show-three": true,
                            "one-prompt": _vm.$t("Pricing.CostPrice"),
                            "two-prompt": _vm.$t("Pricing.VolumePrice"),
                            "three-prompt": _vm.$t("Pricing.MinimumPrice")
                          },
                          on: {
                            onChangeOne: function(p) {
                              _vm.price.threeWeightPrice = p
                            },
                            onChangeTwo: function(p) {
                              _vm.price.threeVolumePrice = p
                            },
                            onChangeThree: function(p) {
                              _vm.price.minimumTonPrice3 = p
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "isFrequency",
                        attrs: {
                          required: "",
                          label: _vm.$t("Pricing.DepartureDay")
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "isFrequency",
                            disabled: true,
                            value: _vm.isFrequency
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("el-checkbox", {
                          staticStyle: {
                            "margin-right": "12px",
                            width: "100%"
                          },
                          attrs: { no: "frequency1", label: 1 },
                          model: {
                            value: _vm.price.frequency1,
                            callback: function($$v) {
                              _vm.$set(_vm.price, "frequency1", $$v)
                            },
                            expression: "price.frequency1"
                          }
                        }),
                        _c("el-checkbox", {
                          staticStyle: {
                            "margin-right": "12px",
                            width: "100%"
                          },
                          attrs: { no: "frequency2", label: 2 },
                          model: {
                            value: _vm.price.frequency2,
                            callback: function($$v) {
                              _vm.$set(_vm.price, "frequency2", $$v)
                            },
                            expression: "price.frequency2"
                          }
                        }),
                        _c("el-checkbox", {
                          staticStyle: {
                            "margin-right": "12px",
                            width: "100%"
                          },
                          attrs: { no: "frequency3", label: 3 },
                          model: {
                            value: _vm.price.frequency3,
                            callback: function($$v) {
                              _vm.$set(_vm.price, "frequency3", $$v)
                            },
                            expression: "price.frequency3"
                          }
                        }),
                        _c("el-checkbox", {
                          staticStyle: {
                            "margin-right": "12px",
                            width: "100%"
                          },
                          attrs: { no: "frequency4", label: 4 },
                          model: {
                            value: _vm.price.frequency4,
                            callback: function($$v) {
                              _vm.$set(_vm.price, "frequency4", $$v)
                            },
                            expression: "price.frequency4"
                          }
                        }),
                        _c("el-checkbox", {
                          staticStyle: {
                            "margin-right": "12px",
                            width: "100%"
                          },
                          attrs: { no: "frequency5", label: 5 },
                          model: {
                            value: _vm.price.frequency5,
                            callback: function($$v) {
                              _vm.$set(_vm.price, "frequency5", $$v)
                            },
                            expression: "price.frequency5"
                          }
                        }),
                        _c("el-checkbox", {
                          staticStyle: {
                            "margin-right": "12px",
                            width: "100%"
                          },
                          attrs: { no: "frequency6", label: 6 },
                          model: {
                            value: _vm.price.frequency6,
                            callback: function($$v) {
                              _vm.$set(_vm.price, "frequency6", $$v)
                            },
                            expression: "price.frequency6"
                          }
                        }),
                        _c("el-checkbox", {
                          staticStyle: {
                            "margin-right": "12px",
                            width: "100%"
                          },
                          attrs: { no: "frequency7", label: 7 },
                          model: {
                            value: _vm.price.frequency7,
                            callback: function($$v) {
                              _vm.$set(_vm.price, "frequency7", $$v)
                            },
                            expression: "price.frequency7"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.ClosingDay") } },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "closingDay",
                            disabled: true,
                            value: _vm.price.closingDay
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-checkbox-group",
                      {
                        model: {
                          value: _vm.closingDay,
                          callback: function($$v) {
                            _vm.closingDay = $$v
                          },
                          expression: "closingDay"
                        }
                      },
                      _vm._l(_vm.frequencys, function(code) {
                        return _c(
                          "el-col",
                          { key: code, staticStyle: { width: "14%" } },
                          [
                            _c("el-checkbox", {
                              attrs: { no: "closingDay", label: code }
                            })
                          ],
                          1
                        )
                      }),
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "days",
                        attrs: {
                          required: true,
                          label: _vm.$t("Pricing.DaysUnitSea")
                        }
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "100%" },
                          attrs: { no: "days" },
                          model: {
                            value: _vm.price.days,
                            callback: function($$v) {
                              _vm.$set(_vm.price, "days", $$v)
                            },
                            expression: "price.days"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          required: "",
                          label: _vm.$t("Pricing.volumeWeightRatio")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "volumeWeightRatio",
                            "select-type":
                              _vm.selectTypeNames
                                .local_cache_SystemConstants$VOLUME_WEIGHT_RATIO,
                            "custom-label": function(item) {
                              return item.name
                            },
                            "show-custom-label-in-option": true,
                            clearable: true,
                            "default-value": _vm.price.volumeWeightRatio
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.volumeWeightRatio = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "minRateValue",
                        attrs: { label: _vm.$t("Pricing.minRateValue") }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-input", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.price.minRateUnit !== "最低价",
                                  expression: "price.minRateUnit !== '最低价'"
                                }
                              ],
                              staticStyle: { width: "140px" },
                              attrs: {
                                placeholder: _vm.$t("Pricing.PleaseNumber"),
                                no: "minRateValue"
                              },
                              model: {
                                value: _vm.price.minRateValue,
                                callback: function($$v) {
                                  _vm.$set(_vm.price, "minRateValue", $$v)
                                },
                                expression: "price.minRateValue"
                              }
                            }),
                            _c("cargo-advance-select", {
                              attrs: {
                                no: "minRateUnit",
                                "select-type":
                                  _vm.selectTypeNames.local_cache_ChargeUnit,
                                clearable: false,
                                "default-value": _vm.price.minRateUnit
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.price.minRateUnit = p.code
                                  _vm.price.minRateValue = 0
                                }
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.DestinationAgent") } },
                      [
                        _c(
                          "div",
                          { attrs: { title: _vm.destinationAgentTitle } },
                          [
                            _c("cargo-advance-select", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                no: "destinationAgent",
                                filterable: "",
                                "select-type":
                                  _vm.selectTypeNames.basic_data_Company,
                                "method-params": { designationAgent: true },
                                "show-custom-label-in-option": true,
                                multiple: true,
                                "default-multiple-value":
                                  _vm.price.destinationAgent
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.price.destinationAgent = p.value
                                }
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.priceNature") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "priceNature",
                            "select-type":
                              _vm.selectTypeNames
                                .local_cache_PriceConstant$PRICE_NATURE,
                            "show-custom-label-in-option": true,
                            "default-value": _vm.price.priceNature
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.priceNature = p.value
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "section form-column" },
              [
                _c(
                  "el-form",
                  {
                    attrs: {
                      disabled: _vm.readonly,
                      "label-width": "100px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("SeaExport.WarehouseSupplier") }
                      },
                      [
                        _c("cargo-advance-select", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            "select-type":
                              _vm.selectTypeNames.basic_data_Company,
                            filterable: "",
                            "default-value":
                              _vm.price.warehouseVendorCmpIdx || "",
                            "tag-name": "chineseName",
                            "method-params": { warehouse: true }
                          },
                          on: { parentCallBack: _vm.warehouseCmpChangeHandler }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.WareHouseName") } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              no: "warehouseUuid",
                              "allow-create": true,
                              filterable: "",
                              clearable: true
                            },
                            model: {
                              value: _vm.price.warehouseUuid,
                              callback: function($$v) {
                                _vm.$set(_vm.price, "warehouseUuid", $$v)
                              },
                              expression: "price.warehouseUuid"
                            }
                          },
                          _vm._l(_vm.warehouseNameList, function(item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label: item.warehouseName || " ",
                                value: item.uuid
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.PriceState") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "priceState",
                            "select-type":
                              _vm.selectTypeNames
                                .local_cache_PriceConstant$PRICE_STATE,
                            "show-custom-label-in-option": true,
                            "default-value": _vm.price.priceState,
                            clearable: false
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.priceState = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.PriceTrend") } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            staticStyle: {
                              display: "flex",
                              "margin-top": "3px"
                            },
                            attrs: { no: "trend" },
                            model: {
                              value: _vm.price.trend,
                              callback: function($$v) {
                                _vm.$set(_vm.price, "trend", $$v)
                              },
                              expression: "price.trend"
                            }
                          },
                          [
                            _c(
                              "el-radio",
                              { attrs: { no: "rise", label: 1 } },
                              [_vm._v(_vm._s(_vm.$t("Pricing.Rise")))]
                            ),
                            _c(
                              "el-radio",
                              { attrs: { no: "fair", label: 0 } },
                              [_vm._v(_vm._s(_vm.$t("Pricing.Fair")))]
                            ),
                            _c(
                              "el-radio",
                              { attrs: { no: "fall", label: -1 } },
                              [_vm._v(_vm._s(_vm.$t("Pricing.Fall")))]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "beginDate",
                        attrs: {
                          required: "",
                          label: _vm.$t("Pricing.BeginDate")
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { flex: "1" },
                              attrs: {
                                no: "beginDate",
                                type: "date",
                                "value-format": "yyyy-MM-dd",
                                clearable: ""
                              },
                              model: {
                                value: _vm.price.beginDate,
                                callback: function($$v) {
                                  _vm.$set(_vm.price, "beginDate", $$v)
                                },
                                expression: "price.beginDate"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "endDate",
                        attrs: {
                          required: "",
                          label: _vm.$t("Pricing.EndDate")
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { flex: "1" },
                              attrs: {
                                no: "endDate",
                                type: "date",
                                "value-format": "yyyy-MM-dd",
                                clearable: ""
                              },
                              model: {
                                value: _vm.price.endDate,
                                callback: function($$v) {
                                  _vm.$set(_vm.price, "endDate", $$v)
                                },
                                expression: "price.endDate"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.Remarks") } },
                      [
                        _c("cargo-rich-textarea", {
                          staticStyle: { "min-height": "80px" },
                          attrs: {
                            no: "remarks",
                            "text-chars": 0,
                            "warning-count": -1
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.Remarks"),
                                _vm.price.remarks,
                                function(val) {
                                  _vm.price.remarks = val
                                }
                              )
                            }
                          },
                          model: {
                            value: _vm.price.remarks,
                            callback: function($$v) {
                              _vm.$set(_vm.price, "remarks", $$v)
                            },
                            expression: "price.remarks"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ])
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "modal-append-to-body": false,
            "append-to-body": true
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            }
          }
        },
        [
          _c("cargo-rich-textarea", {
            ref: "advanceTextDialogTextarea",
            staticStyle: { height: "198px" },
            attrs: {
              no: "advanceTextDialogValue",
              disabled: _vm.readonly,
              required: false,
              "text-chars": _vm.advanceTextDialog.formatObj.maxChar,
              "warning-count": _vm.advanceTextDialog.formatObj.warningCount
            },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.readonly,
                      expression: "!readonly"
                    }
                  ],
                  attrs: { no: "finishAdvanceText", type: "primary" },
                  on: { click: _vm.finishAdvanceText }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "advanceTextDialogClose" },
                  on: {
                    click: function($event) {
                      _vm.advanceTextDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }